// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentPatientUpdateRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentPatientUpdateRequestModel.attributeTypeMap;
    }
}
EnrollmentPatientUpdateRequestModel.discriminator = undefined;
EnrollmentPatientUpdateRequestModel.additionalProperties = false;
EnrollmentPatientUpdateRequestModel.attributeTypeMap = [
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentMedBenClientIdentifiersModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "EnrollmentPatientUpdateDemographicsModel"
    },
];
//# sourceMappingURL=enrollmentPatientUpdateRequestModel.js.map